import { render, staticRenderFns } from "./QqxmAdd.vue?vue&type=template&id=0296ecfe"
import script from "./QqxmAdd.vue?vue&type=script&lang=js"
export * from "./QqxmAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports